export const Error = ({ message, small, style }) => {
  if (!message) return null;
  return (
    <div
      style={{
        border: small ? '' : '0px solid red',
        background: small ? '' : '#ff000022',
        padding: small ? null : '8px 12px',
        fontSize: small ? 12 : 14,
        margin: '4px 0',
        color: '#d00',
        fontWeightx: 'bold',
        borderRadius: 4,
        ...style,
      }}
    >
      {typeof message == 'string' ? message : JSON.stringify(message)}
    </div>
  );
};
